import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu' 
import { useBaseStore } from '@/store'
import { appConfigActionsSelector } from '@/store/appConfigSlice'
import { authActionsSelector } from '@/store/authSlice'
import { useQueryClient } from '@tanstack/react-query'
import { Key, LogOut } from 'lucide-react'
import { ReactNode } from 'react'

interface ProfileMenuProps {
    trigger: ReactNode
    className?: string
}

const ProfileMenu = ({ trigger, className }: ProfileMenuProps) => {
    const { onChangePasswordDialogOpen } = useBaseStore(
        appConfigActionsSelector
    ) 

    const { logout } = useBaseStore(authActionsSelector)

    const queryClient = useQueryClient()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className={className}>
                {trigger}
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[220px] bg-gray-800 border-none">
                <DropdownMenuGroup>
                    <DropdownMenuLabel>Conta</DropdownMenuLabel>
                    <DropdownMenuItem
                        className="gap-2"
                        onClick={onChangePasswordDialogOpen}
                    >
                        <Key size={14} />
                        Alterar senha
                    </DropdownMenuItem>
                </DropdownMenuGroup>
                <DropdownMenuSeparator /> 

                <DropdownMenuItem
                    className="gap-2"
                    onClick={() => logout(queryClient)}
                >
                    <LogOut size={14} />
                    Sair
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default ProfileMenu
